import React, { lazy } from 'react';

import { RouteObject } from 'react-router-dom';

const JoinTeam = lazy(() => import('@pages/landing/JoinTeam'));

export const JoinTeamRoutes: RouteObject[] = [
  {
    path: '/join-team',
    element: (
      <React.Suspense>
        <JoinTeam />
      </React.Suspense>
    ),
  },
];
